export const api={
  queryPhoneByAccount: '/cms/forgetpassword/queryPhoneByAccount.json',
  //发送验证码
  queryVerificationCode: '/cms/forgetpassword/queryVerificationCode.json',
  //验证验证码
  checkVerificationCode: '/cms/forgetpassword/checkVerificationCode.json',
  //重置密码
  resetPassword: '/cms/forgetpassword/resetPassword.json' 
}